import { ActionConfig, ActionContext, IAction } from '../Action'

export class SaveForLaterAction implements IAction {
    static Id = 'SaveForLater' as const
    constructor(
        private actionContext: ActionContext,
        private config?: ActionConfig
    ) {
        if (
            !this.actionContext.studio.taskConfig.assignment.task.config.save_for_later_config
                ?.is_enabled
        ) {
            console.warn('Save for later is not enabled')
            return
        }
        this.addToWorkbench()
    }

    addToWorkbench() {
        this.actionContext.workbenchUiAccessor?.toolbar.addAction({
            id: 'save-for-later',
            title: this.config?.title ?? 'Save For Later',
            type: 'button',
            onClick: () => {
                this.actionContext.modalManager?.showModal('save-for-later')
            },
            isCollapsed: this.config?.isCollapsed ?? true,
            disabled: this.config?.disabled ?? false,
            tooltip: this.config?.tooltip,
        })
    }

    removeFromWorkbench() {
        this.actionContext.workbenchUiAccessor?.toolbar.removeAction('save-for-later')
    }
}
